function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FF4056",
  d: "M43 25c0 9.94-8.06 18-18 18-9.942 0-18-8.06-18-18S15.058 7 25 7c9.94 0 18 8.06 18 18",
  opacity: 0.15
}), React.createElement("path", {
  fill: "#FF4056",
  d: "M50 25c0 13.806-11.194 25-25 25C11.192 50 0 38.806 0 25S11.192 0 25 0c13.806 0 25 11.194 25 25",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#FF4056",
  d: "M37 25c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M30.11 30.606a.703.703 0 0 1-.68-.182l-9.854-9.855a.703.703 0 0 1 .993-.994l9.855 9.856a.702.702 0 0 1-.314 1.175"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M20.254 30.606a.702.702 0 0 1-.679-1.175l9.856-9.856a.703.703 0 1 1 .994.994l-9.857 9.856a.695.695 0 0 1-.314.181"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50
  }, props), _ref);
};

export default SvgComponent;